import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    size?: number | string
    style?: React.CSSProperties
    color?: string
    className?: string
}

export function ExternalLinkFarFAIcon({ size = 16, color, style, className, ...others }: Props) {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="external-link"
            className={`svg-inline--fa fa-external-link fa-w-10 fa-fw ${className}`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            color={color}
            style={{ width: size, height: size, ...style }}
            {...others}
        >
            <path
                fill="currentColor"
                d="M13.5 1.5H10V0h6v6h-1.5V2.5L6.75 8.25 5.75 7.25 11.5 1.5zM14 9v5.5H1.5V2h5.5V0.5H1.5C0.675 0.5 0 1.175 0 2v12.5C0 15.325 0.675 16 1.5 16h12.5c0.825 0 1.5-0.675 1.5-1.5V9h-1.5z"
            />
        </svg>
    )
}
